<template>
  <div>
    <ots-main-title :mainTopBtn="mainTopBtnList" />
    <div class="topTip">
      <span class="f18 col_black mr20"
        >批次：{{ planName }} 课程：{{ courseName }}
      </span>
    </div>
    <div class="searchBox">
      <ots-refer
        class="mb20"
        :selectList="selectList"
        :request-form="stuSelectParams"
        @search="getStuList"
      />
    </div>
    <div class="tableBorder">
      <!-- 组件样式不符合, 单独配置该按钮 -->
      <div
        :class="[isUse_SetErrorList ? 'batchOperation' : 'batchOperationDis']"
        v-if="batchOperBtn.length > 0"
        style="margin-left: 20px;"
      >
        <ul>
          <li
            class="batchBtn"
            v-for="item in batchOperBtn"
            :key="item.title"
            @click="item.click()"
          >
            <a href="javascript:;">
              <i :class="item.icon"></i>
              <span>{{ item.title }}</span>
            </a>
          </li>
        </ul>
      </div>

      <!-- 优秀/及格/不及格 人数 -->
      <p class="col_blue mb10" style="margin-left: 20px;">
        {{ totalText }}
        <span style="color: red; margin-left: 20px;">说明：分数为学生原始作答分数，成绩为发布后学生平台的查询结果</span>
      </p>

      <!-- 表格 -->
      <ots-table-group-new
        :tableHeader="tableHeader"
        :tableData="tableData"
        :tableOption="tableOption"
        @handleSelectionChange="bachOper"
        :pagination="pagination"
        @changeNum="changeSize"
        @changePage="changePage"
      ></ots-table-group-new>
    </div>

    <ots-custom-dialog :dialog.sync="lookImgAll" title="查看违纪照片">
      <template v-slot:content>
        <div class="dialogImg">
        <div
          v-for="item in disciplineImg"
          :key="item.index"
          class="disciplineImg"
        >
          <img :src="item" alt="" />
        </div>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="lookImgAll = false">关闭</el-button>
      </template>
    </ots-custom-dialog>

    <!-- 批量设置异常 -->
    <ots-custom-dialog :dialog.sync="batchSetError" title="设置考试状态">
      <template v-slot:content>
        <div>
          <p class="studentNumber">
            为您所需选择的
            <span class="col_red">{{ selectIds.length }}</span> 个学生设置！
          </p>
          <el-form inline label-width="80px">
            <div>
              <el-form-item label="考试状态">
                <el-select
                  v-model="batchSignParams.examState"
                  placeholder="请选择"
                >
                  <el-option
                    v-for="item in examSignList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <p class="col_red mt15">
                  设置后学生考试分数将置为0，请慎重操作！
                </p>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="batchSetError = false">取消</el-button>
        <el-button round type="primary" @click="batchSetSign">确定</el-button>
      </template>
    </ots-custom-dialog>

    <ots-custom-dialog :dialog.sync="importDialog" title="导入成绩" width="40%">
      <template v-slot:content>
        <div class="exportDialog">
          <el-form ref="exportForm" :model="importForm">
            <el-form-item label="1.模板下载">
              <span style="color: #006aff" @click="getStaticFile" class="cp">
                <i class="el-icon-download"></i>
                下载考试异常状态导入数据模板
              </span>
            </el-form-item>
            <el-form-item label="2.选择文件" v-model="importForm.file">
              <ots-upload-file :httpRequest="handleFormData" fileType="xlsx" />
            </el-form-item>
          </el-form>
          <div class="impExplain">
            <span class="tipTitle"><i></i>提示：</span>
            <div>
              <div>1：模板中<span class="col_red">*</span>字段为必填项</div>
              <div>
                2：只能上传扩展名为<span class="col_red">.xlsx</span>的文件；
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="importDialog = false">取消</el-button>
        <el-button round type="primary" @click="scoreImport">确定</el-button>
      </template>
    </ots-custom-dialog>

    <!-- 单个处理异常弹窗 -->
    <ots-custom-dialog :dialog.sync="signDialog" title="设置考试状态">
      <template v-slot:content>
        <div>
          <el-form inline label-width="100px">
            <div>
              <el-form-item label="学生姓名">
                <span>{{ currentStudent.realName }}</span>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="证件号码">
                <span>{{ currentStudent.cardNo }}</span>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="考试状态">
                <el-select v-model="signParams.checkState" placeholder="请选择">
                  <el-option
                    v-for="item in examSignList"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
                <p class="col_red mt15">
                  设置后学生考试分数将置为0，请慎重操作！
                </p>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="考生详情">
                <div class="BubbleTrigger">
                  <el-link type="primary" @click="lookDetailRight()">查看考生详情</el-link>
                  <div class="bubbleSelf" v-if="showBubble">
                    <button class="close-btn" @click.stop="closeBubble">×</button>
                    <div>
                      <div class="radio" style="margin-left:15px;">
                        排序：
                        <el-radio-group v-model="reverse" style="padding-top: 10px; box-sizing: border-box">
                          <el-radio :label="false">正序</el-radio>
                          <el-radio :label="true">倒序</el-radio>
                        </el-radio-group>
                      </div>

                      <el-timeline :reverse="reverse" class="timeline" style="margin:20px 0 0 20px;">
                        <el-timeline-item
                          v-for="(activity, index) in activities"
                          :key="index"
                          color="#006aff"
                          :timestamp="activity.nodeTime"
                        >
                          {{activity.nodeName}}<br />
                          <img
                            :src="activity.dataContent"
                            width="100"
                            height="100"
                            class="imgCss"
                            v-if="activity.dataType === 'Url'"
                            @click="showBigImg(activity.dataContent)">
                        </el-timeline-item>
                      </el-timeline>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="巡考违纪照片">
                <div class="showImgClass" v-if="imageList1 && imageList1.length > 0">
                  <div
                    v-for="item in imageList1"
                    :key="item.index"
                    class="showImgClassInner"
                  >
                    <img :src="item" alt="" />
                  </div>
                </div>
                <div class="showImgClass" v-else>无</div>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="考中违纪照片">
                <div class="showImgClass" v-if="imageList2 && imageList2.length > 0">
                  <div
                    v-for="item in imageList2"
                    :key="item.index"
                    class="showImgClassInner"
                  >
                    <img :src="item" alt="" />
                  </div>
                </div>
                <div class="showImgClass" v-else>无</div>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="补充违纪材料">
                <el-upload
                  class="upload-demo"
                  action=""
                  :on-remove="handleRemove"
                  :on-change="handleSuccess"
                  :file-list="fileList"
                  :before-upload="beforeAvatarUpload"
                  :http-request="uploadImg"
                  list-type="picture">
                  <el-button size="small" type="primary">点击上传</el-button>
                </el-upload>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="补充描述">
                <el-input
                  type="textarea"
                  v-model="signParams.checkStateRemark"
                  placeholder="如有补充说明，请在此添加"
                  rows="5"
                  maxlength="200"
                  style="width: 350px;"
                  show-word-limit>
                </el-input>
              </el-form-item>
            </div>
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="signDialog = false">取消</el-button>
        <el-button round type="primary" @click="setSign">确定</el-button>
      </template>
    </ots-custom-dialog>

    <!-- 单个处理异常弹窗--查看 -->
    <ots-custom-dialog :dialog.sync="signShowDialog" title="查看异常状态">
      <template v-slot:content>
        <div>
          <el-form inline label-width="100px">
            <div>
              <el-form-item label="学生姓名">
                <span>{{ currentStudent.realName }}</span>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="证件号码">
                <span>{{ currentStudent.cardNo }}</span>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="考试状态">
                {{ nowCheckStateName }}
              </el-form-item>
            </div>
            <div>
              <el-form-item label="考生详情">
                <div class="BubbleTrigger">
                  <el-link type="primary" @click="lookDetailRight()">查看考生详情</el-link>
                  <div class="bubbleSelf" v-if="showBubble">
                    <button class="close-btn" @click.stop="closeBubble">×</button>
                    <div>
                      <div class="radio" style="margin-left:15px;">
                        排序：
                        <el-radio-group v-model="reverse" style="padding-top: 10px; box-sizing: border-box">
                          <el-radio :label="false">正序</el-radio>
                          <el-radio :label="true">倒序</el-radio>
                        </el-radio-group>
                      </div>

                      <el-timeline :reverse="reverse" class="timeline" style="margin:20px 0 0 20px;">
                        <el-timeline-item
                          v-for="(activity, index) in activities"
                          :key="index"
                          color="#006aff"
                          :timestamp="activity.nodeTime"
                        >
                          {{activity.nodeName}}<br />
                          <img
                            :src="activity.dataContent"
                            width="100"
                            height="100"
                            class="imgCss"
                            v-if="activity.dataType === 'Url'"
                            @click="showBigImg(activity.dataContent)">
                        </el-timeline-item>
                      </el-timeline>
                    </div>
                  </div>
                </div>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="巡考违纪照片">
                <div class="showImgClass" v-if="imageList1 && imageList1.length > 0">
                  <div
                    v-for="item in imageList1"
                    :key="item.index"
                    class="showImgClassInner"
                    @click = "bigImg(item)"
                  >
                    <img :src="item" alt=""/>
                  </div>
                </div>
                <div class="showImgClass" v-else>无</div>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="考中违纪照片">
                <div class="showImgClass" v-if="imageList2 && imageList2.length > 0">
                  <div
                    v-for="item in imageList2"
                    :key="item.index"
                    class="showImgClassInner"
                    @click = "bigImg(item)"
                  >
                    <img :src="item" alt="" />
                  </div>
                </div>
                <div class="showImgClass" v-else>无</div>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="补充违纪材料">
                <div class="showImgClass" v-if="imageList3 && imageList3.length > 0">
                  <div
                    v-for="item in imageList3"
                    :key="item.index"
                    class="showImgClassInner"
                    @click = "bigImg(item)"
                  >
                    <img :src="item" alt="" />
                  </div>
                </div>
                <div class="showImgClass" v-else>无</div>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="补充描述">
                {{ nowCheckStateRemark ? nowCheckStateRemark : "无"}}
              </el-form-item>
            </div>
          </el-form>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="signShowDialog = false">关闭</el-button>
      </template>
    </ots-custom-dialog>

    <el-drawer title="查看考生详情" :visible.sync="lookFlag" direction="ltr" >
      <div style="margin-left: 50px;">
        <div class="radio" style="margin-bottom: 20px;">
          排序：
          <el-radio-group v-model="reverse" style="padding-top: 10px; box-sizing: border-box">
            <el-radio :label="false">正序</el-radio>
            <el-radio :label="true">倒序</el-radio>
          </el-radio-group>
        </div>

        <el-timeline :reverse="reverse" class="timeline" style="margin-left: 50px;">
          <el-timeline-item
            v-for="(activity, index) in activities"
            :key="index"
            color="#006aff"
            :timestamp="activity.nodeTime"
          >
            {{activity.nodeName}}<br />
            <img
              :src="activity.dataContent"
              width="100"
              height="100"
              class="imgCss"
              v-if="activity.dataType === 'Url'"
              @click="showBigImg(activity.dataContent)">
          </el-timeline-item>
        </el-timeline>
      </div>
    </el-drawer>

    <ots-custom-dialog :dialog.sync="gradeDialog" title="考生单科成绩" width="480px">
      <template v-slot:content>
        <div class="score_dialog">
          <p class="info"><span>姓名：</span>{{gradeForm.realName}}</p>
          <p class="info"><span>证件号：</span>{{gradeForm.cardNo}}</p>
          <p class="info"><span>准考证号：</span>{{gradeForm.entranceCode}}</p>
          <p class="line"></p>
          <p class="score title"><span>{{gradeForm.courseName}}：</span><span>{{gradeForm.score}}</span></p>
          <p class="score" v-for="item in gradeForm.data" :key="item.subCourseId"><span>{{item.subCourseName}}：</span><span>{{item.score}}</span></p>
        </div>
      </template>
      <template v-slot:footer>
        <el-button round @click="gradeDialog = false">关闭</el-button>
      </template>
    </ots-custom-dialog>

  </div>
</template>
<script>
import {
  getStudentScoreListFn,
  getOtsUrlFn,
  changeExamCheckStateFn,
  queryExamCheckStateFn,
  exportStudentScoreFn,
  getExamCheckStateFn,
  importCheckStateFileexcel,
  getCheckStateTemplateexcel,
  getStudentSubCourseListAPI
} from "@/http/modules/examSet/score";

import { getCurrentPlanFn } from "@/http/modules/examSet/examBatch";
import { getPlaceInfofn } from "@/http/modules/baseSet/majorCourse";
import { batchHumanAudit } from "@/http/modules/examSet/varAudit.js";
import { queryDetailListAPI } from "@/http/modules/computedRoomExam";
import { getPlanSite } from "@/http/modules/examSet/section";

const photoState = {
  0: "未通过",
  1: "通过",
  2: "-",
};
export default {
  name: "currentScore",
  data() {
    return {
      lookFlag: false,
      reverse: false,
      activities: [],
      nowCheckStateName: "",
      nowCheckStateRemark: "",
      imageList1: [],
      imageList2: [],
      imageList3: [],
      fileList: [],
      changePhoto: false,
      importForm: {
        file: "",
      },
      disciplineImg: [],
      lookImgAll: false,
      importDialog: false,
      signDialog: false,
      signShowDialog: false,
      currentStudent: {},
      examSignList: [],
      totalText: "",
      planInfo: {},
      studentInfo: {},
      mainTopBtnList: [
        {
          title: "导出",
          fn: this.exportScore,
        },
        {
          title: "考试异常状态导入",
          fn: this.importStationDialog,
        },
      ],
      selectList: [
        {
          title: "关键词",
          type: "input",
          placeholder: "姓名/准考证/证件号",
          requestKey: "searchKey",
        },
        {
          title: "系统验证",
          type: "select",
          requestKey: "systemAuditStatus",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
            { id: 1, name: "通过" },
            { id: 0, name: "未通过" },
          ],
        },
        {
          title: "人工审核",
          type: "select",
          requestKey: "humanAuditState",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
            { id: 0, name: "待审核" },
            { id: 2, name: "审核通过" },
            { id: 1, name: "审核不通过" },
          ],
        },
        {
          title: "考试状态",
          type: "select",
          multiple: true,
          requestKey: "checkState",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "教学点",
          type: "select",
          requestKey: "stationId",
          isSearch: true,
          multiple: true,
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "分数段",
          type: "inputInterval",
          placeholder: "例如0-59",
          requestKey: "minScore",
          requestKeySecond: "maxScore",
        },
        {
          title: "考点",
          type: "select",
          isSearch: true,
          multiple: true,
          requestKey: "placeId",
          label: "placeName",
          value: "placeId",
          data: [],
        },
        {
          title: "教室",
          type: "select",
          isSearch: true,
          requestKey: "classId",
          label: "name",
          value: "id",
          data: [],
        },
        {
          title: "座位号",
          type: "input",
          placeholder: "输入座位号(1~999)",
          requestKey: "seatNo",
        },
        {
          title: "强制交卷",
          type: "select",
          requestKey: "forceSubmit",
          label: "name",
          value: "id",
          data: [
            { id: "", name: "全部" },
            { id: "1", name: "是" },
            { id: "0", name: "否" }
          ]
        }
      ],
      stuSelectParams: {
        searchKey: "",
        systemAuditStatus: "",
        humanAuditState: "",
        scorePublish: 0,
        planId: "",
        stationId: [""],
        placeId: [""],
        classId: "",
        minScore: "",
        checkState: [],
        maxScore: "",
        forceSubmit: ""
      },
      batchSignParams: {
        examState: "",
        planId: "",
        studentCourseIds: "",
      },
      signParams: {
        checkState: "",
        base64List: [],
        checkStateRemark: "",
      },
      tableHeader: [
        {
          title: "姓名",
          prop: "realName",
          width: "90",
          fixed: "left"
        },
        {
          title: "准考证号",
          prop: "entranceCode",
          type : "textTooltip",
          fixed: "left",
          width: "150",
          data: function(scope) {
            let obj = "";
            obj += `<div style="line-height:25px; padding:1px 5px 1px 5px;">教学点：${scope.row.stationName}</div>`;
            obj += `<div style="line-height:25px; padding:1px 5px 1px 5px;">考点：${scope.row.placeName}</div>`;
            obj += `<div style="line-height:25px; padding:1px 5px 1px 5px;">教室：${scope.row.className}</div>`;
            obj += `<div style="line-height:25px; padding:1px 5px 1px 5px;">座位号：${scope.row.seatNo}</div>`;
            return obj;
          },
        },
        {
          title: "证件号",
          prop: "cardNo",
          fixed: "left",
          width: "150"
        },
        // {
        //   title: "教学点",
        //   prop: "stationName",
        // },
        // {
        //   title: "考点",
        //   prop: "placeName",
        // },
        {
          title: "分数",
          prop: "score",
          width: "60",
        },
        {
          title: "客观题分数",
          prop: "objectiveScore",
        },
        {
          title: "主观题分数",
          prop: "subjectiveScore",
        },
        {
          title: "单科成绩",
          type: "button",
          width: "120",
          prop: "singleGrades",
          formatter: (val) => { return "查看" },
          disableFn: (val) => val.row.checkState == "正常" &&  val.row.courseFlag == 1 ? false : true,
          click: this.goSingleGrades,
        },
        {
          title: "作答详情",
          type: "button",
          prop: "studentCount",
          width: "120",
          formatter: (val) =>
            val.row.checkState == "缺考"
              ? ""
              : val.row.recordId == "scoreimport"
              ? ""
              : "查看",
          disableFn: (val) =>
            val.row.result == "-" || val.row.checkState == "缺考"
              ? true
              : false,
          click: this.goOTS,
        },
        // { //187684 山师：修改作弊状态，允许写文字和看时间轴 这个任务要求去掉违纪照片
        //   title: "违纪照片",
        //   type: "button",
        //   prop: "photo",
        //   formatter: (val) =>
        //     (val.row.stateUrl  === null || val.row.stateUrl.length == 0) ? '':'查看' ,
        //   click: this.loolImg,
        //   disableFn: (val) => ( (val.row.stateUrl  === null || val.row.stateUrl.length == 0) ? true : false),
        // },
        {
          title: "OTS系统审核",
          prop: "photoCheckState",
          formatter: (val) => photoState[val.row.photoCheckState] || "",
        },
        {
          title: "人工审核",
          prop: "humanAuditState",
          width: "90",
        },
        {
          title: "考试状态",
          prop: "checkState",
          width: "90",
        },
        {
          title: "成绩",
          prop: "result",
          width: "90",
        },
        {
          title: "发布状态",
          prop: "placeNames",
          formatter: (val) => (val.row.scorePublish == 1 ? "已发布" : "未发布"),
        },
        {
          title: "操作",
          type: "buttons",
          width: "150",
          fixed: "right",
          btnList:[
            {
              title: (val) => val.row.checkState !== "" && val.row.checkState !== "缺考" && val.row.checkState !== "正常" ? "查看异常" : "",
              formatter: (val) => (val.row.checkState !== "" && val.row.checkState !== "缺考" && val.row.checkState !== "正常" ? false : true),
              click: this.seeCheckState,
            },
            {
              title: (val) =>
                val.row.checkState == "缺考" || val.row.checkState == ""
                  ? ""
                  : val.row.checkState == "正常"
                  ? "设置异常"
                  : "恢复正常",
              formatter: (val) => (val.row.checkState == "缺考" || val.row.checkState == "" ? true : false),
              click: this.setCheckState,
            }
          ]
        },
      ],
      tableData: [],
      tableOption: {
        multiple: true,
        selectTable: this.isDisabledMultiple,
      },
      pagination: {
        total: 0,
      },
      stuListParams: {
        planId: "",
        page: 1,
        size: 10,
      },
      exportForm: {
        exportType: 1,
      },
      planName: "",
      courseName: "",
      selectIds: [],
      batchOperBtn: [
        {
          title: "返回",
          click: () => {
            this.$router.go(-1);
          },
        },
        // { //187684 山师：修改作弊状态，允许写文字和看时间轴 这个任务要求去掉这个按钮
        //   title: "批量设置异常",
        //   icon: "iconfont icon-bianji",
        //   click: this.setErrorList,
        // },
      ],
      batchSetError: false,
      currentPlans: {},

      gradeForm: {
        realName: '',
        entranceCode: '',
        score: '',
        cardNo: '',
        courseName: this.$route.query.courseName,
        data: [],
      },

      gradeDialog: false,

      showBubble: false,
    };
  },
  watch: {
    "stuSelectParams.planId": function (val) {
      this.stuSelectParams.placeId = [];
      this.stuSelectParams.stationId = [];
      this.$set(this.selectList[4], "data", []);
    },
    "stuSelectParams.stationId": function () {
      this.getPlaceListFn();
      this.getStuList();
    },
    "stuSelectParams.placeId": function (val) {
      this.$set(this.selectList[7], "data", []);
      this.stuSelectParams.classId = "";
      this.getClassList();
    },
  },
  created() {
    this.planName = this.$route.query.planName;
    this.courseName = this.$route.query.courseName;
    this.initData();
    this.getPlans();
    this.getExamStatus();
    // this.getPlaceListFn();
    // this.getStuList();
  },
  computed: {
    isUse_SetErrorList() {
      let scorePublish = this.$route.query.scorePublish;
      if (scorePublish == 1) {
        return false;
      }
      return true;
    },
  },
  methods: {
    async goSingleGrades(row) {
      let { planId, courseId } = this.$route.query;
      let params = {
        planId,
        courseId,
        stuId: row.userId,
      }
      const { data } = await getStudentSubCourseListAPI(params);
      this.gradeForm.score = row.score;
      this.gradeForm.realName = row.realName;
      this.gradeForm.entranceCode = row.entranceCode;
      this.gradeForm.cardNo = row.cardNo;
      this.gradeForm.data = data;
      this.gradeDialog = true;
    },

    handleRemove(file, fileList) {
      this.fileList = fileList;
    },
    
    handleSuccess(file, fileList) {
      this.fileList = fileList;
    },

    // 未配置 action, 覆盖一下默认上传行为
    uploadImg(data) {
      let that = this;
      let fileData = data.file;
      let reader = new FileReader();
      reader.readAsDataURL(fileData);
      reader.onload = function (e) {
        if (e.currentTarget.result) {
          that.fileList.map((item, index)=> {
            if (item.name == data.file.name) {
              that.fileList[index].url = e.currentTarget.result;
            }
          })
        }
      };
      this.changePhoto = false;
    },

    beforeAvatarUpload(fileData) {
      let ImgRules = ["jpg", "jpeg", "png"]
      let type = fileData.name.substring(fileData.name.lastIndexOf(".") + 1);
      const isJPG = ImgRules.indexOf(type) !== -1;
      const isLt30kb = fileData.size / 1024 < 2048;
      if (!isJPG && !isLt30kb) {
        this.$message.error(`该批次上传图片只能是 "jpg", "jpeg", "png" 格式，且大小不能超过 2048 kb! `);
      } else if (!isJPG) {
        this.$message.error(`该批次上传图片只能是 "jpg", "jpeg", "png" 格式!`);
      } else if (!isLt30kb) {
        this.$message.error(`该批次上传图片大小不能超过 2048 kb!`);
      }
      return isJPG && isLt30kb;
    },


    getStaticFile() {
      getCheckStateTemplateexcel().then((res) => {
        window.location.href = res.data;
      });
    },
    loolImg(val) {
      this.lookImgAll = true;
      this.disciplineImg = val.stateUrl;
    },
    importStationDialog() {
      this.importDialog = true;
    },
    handleFormData(val) {
      this.importForm.file = val.file;
    },
    async scoreImport() {
      // (1) 文件选择判断
      if (!this.importForm.file) {
        this.$message.error("请选择文件");
        return;
      }
      const formData = new FormData();
      formData.append("file", this.importForm.file);
      formData.append("planId", this.$route.query.planId);
      formData.append("courseId", this.$route.query.courseId);
      const { code, data } = await importCheckStateFileexcel(formData);
      if (code == 1) {
        const failNum = data.errorCount ? parseInt(data.errorCount) : 0;
        const successCount = data.successCount;
        let message = `导入完成，成功导入${successCount}，失败数${failNum}`;
        this.importDialog = false;
        this.$confirm(message, "导入结果", {
          confirmButtonText: failNum > 0 ? "查看错误记录" : "确定",
          cancelButtonText: "取消",
          type: failNum > 0 ? "warning" : "success",
        }).then(async () => {
          if (failNum > 0) {
            window.location.href = data.address;
          }
        });
        this.importDialog = false;
      } else {
        this.importDialog = false;
      }
    },
    //获取考试状态下拉数据
    getExamStatus() {
      getExamCheckStateFn().then((res) => {
        if (res.code === 1) {
          this.$set(this.selectList[3], "data", res.data);
        }
      });
    },
    // 当前考试批次
    async getPlans() {
      let res = await getCurrentPlanFn({
        planId: this.$route.query.planId,
      });
      this.currentPlans = res.data;
    },
    /***********************************
     * @setErrorList 批量设置异常(弹窗)
     ***********************************/
    setErrorList() {
      // 1. 成绩是否发布
      if (!this.isUse_SetErrorList) {
        this.$message.warning("成绩已发布，无法设置异常状态！");
        return false;
      }
      // 2. 是否勾选列表
      if (this.selectIds.length > 0) {
        // 3. 初始化数据
        for (let key in this.batchSignParams) {
          this.batchSignParams[key] = "";
        }
        // 4. 批量设置考生异常, 展示弹窗
        this.batchSetError = true;
      } else {
        this.$message.warning("请选择要设置的学生！");
        return false;
      }
    },
    /************************************
     * @setBatchSign 批量设置异常(确定)
     ************************************/
    batchSetSign() {
      // 1. 判断是否可以提交
      if (this.batchSignParams.examState == "") {
        this.$message.warning("请选择考试状态！");
        return;
      }
      // 2. 配置参数
      this.batchSignParams.planId = this.$route.query.planId;
      this.batchSignParams.studentCourseIds = this.selectIds.join(",");
      let params = { ...this.batchSignParams };

      // 3. 再次判断成绩是否发布
      let publicParams = {
        courseId: this.$route.query.courseId,
        type: 0,
      };
      if (this.currentPlans.scorePublish == 0) {
        batchHumanAudit(params).then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功！");
            this.batchSetError = false;
            // 4. 刷新列表
            this.getStuList(true);
          }
        });
      } else {
        this.$message.warning("考试成绩已发布，不能再设置考试状态！");
        this.batchSetError = false;
        return;
      }
    },

    /************************************
     * @this table_表格列表多选是否禁用
     ***********************************/
    isDisabledMultiple(row) {
      let { checkState } = row;
      if (checkState == "正常" || checkState == "") {
        return true;
      }
      return false;
    },

    /************************************
     * @this table_表格选中事件
     ***********************************/
    bachOper(val) {
      let idList = [];
      val.forEach((item) => {
        idList.push(item.studentCourseId);
      });
      this.selectIds = idList;
    },

    /************************************
     * @initData 初始化数据
     ***********************************/
    async initData() {
      const { planId, courseId } = this.$route.query;
      this.stuSelectParams.planId = planId;
      // this.stuSelectParams.courseId = courseId;
      // 获取考试标记列表
      this.mixin_getSelectExamSign().then((data) => {
        this.examSignList = data.filter(
          (item) => item.name != "正常" && item.name != "缺考"
        );
      });
      this.mixin_getSelectStation().then((data) => {
        this.$set(this.selectList[4], "data", data);
      });
      // this.getStuList();
    },
    getPlaceListFn() {
      getPlaceInfofn({
        planId: this.stuSelectParams.planId,
        stationIds: this.stuSelectParams.stationId.toString(),
      }).then((res) => {
        this.$set(this.selectList[6], "data", res.data);
      });
    },
    getClassList() {
      getPlanSite({
        planId: this.stuSelectParams.planId
      }).then((res) => {
        let classList = [];
        res.data.forEach(item => {
          if (this.stuSelectParams.placeId.includes(item.id)) {
            classList = classList.concat(item.placeClassList);
          }
        });
        this.$set(this.selectList[7], "data", classList);
      });
    },
    // 查询考生成绩
    // 2023年11月15日 => 修改分页Bug
    async getStuList(page) {
      let params = Object.assign(this.stuListParams, this.stuSelectParams);
      params.checkState = params.checkState.join(",");
      params.placeId = params.placeId.join(",");
      params.stationId = params.stationId.join(",");
      params.courseId = this.$route.query.courseId;
      if (!page) { params.page = 1}
      const { data } = await getStudentScoreListFn(params);
      this.tableData = data.records;
      this.totalText = data.totalShowText;
      this.pagination.total = data.total;
    },

    async goOTS(row) {
      let params = {
        action: "getTReviewDetails",
        parames: `argumentsId=${row.recordId}&curPage=JudgeLib`,
      };
      const { code, data } = await getOtsUrlFn(params);
      if (code == 1) {
        window.open(data);
      }
    },
    seeCheckState(val){
      this.showBubble = false;
      this.currentStudent = val;
      this.signShowDialog = true;
      this.getPhotoList();
    },
    setCheckState(val) {
      this.showBubble = false;
      this.currentStudent = val;
      const { checkState } = this.currentStudent;
      if (checkState == "正常") {
        this.getPhotoList();
        this.signDialog = true;
      } else {
        this.$confirm("确认将学生考试状态恢复为正常？", "提示")
          .then(() => {
            this.signParams.checkState = 1; // 正常状态为1
            this.setSign();
          })
          .catch(() => {});
      }
    },
    setSign() {
      // 违纪照片
      let photoList = this.fileList.map(e => { return e.url.split(',')[1] });
      this.signParams.base64List = photoList.join(",");

      if (this.signParams.checkState == "") {
        this.$message.warning("请选择考试状态！");
        return;
      }
      const { studentCourseId } = this.currentStudent;
      const params = { ...this.signParams, studentCourseId };
      changeExamCheckStateFn(params).then((res) => {
        if (res.code == 1) {
          this.$message.success("操作成功");
          this.getStuList();
          this.signDialog = false;
          this.signParams.checkState = "";// 重置状态
          this.signParams.checkStateRemark = ""; // 清空补充描述
          this.fileList = []; // 清空文件列表
        }
      });
    },

    async getPhotoList(){
      const { code, data } = await queryExamCheckStateFn({studentCourseId:this.currentStudent.studentCourseId});
      if(code == 1){
        this.nowCheckStateName = data.data.checkStateName;
        this.nowCheckStateRemark = data.data.checkStateRemark;
        this.imageList1 = data.data.url001;
        this.imageList2 = data.data.url002;
        this.imageList3 = data.data.url003;
      }
    },

    exportScore() {
      let params = Object.assign({}, this.stuSelectParams, {
        courseId: this.$route.query.courseId,
      });

      params.checkState = params.checkState.join(",");
      params.placeId = params.placeId.join(",");
      params.stationId = params.stationId.join(",");
      exportStudentScoreFn(params).then(({ code, data }) => {
        if (code) {
          window.open(data);
        }
      });
    },
    changeSize(num) {
      this.stuListParams.size = num;
      this.getStuList();
    },
    changePage(p) {
      this.stuListParams.page = p;
      this.getStuList(true);
    },
    async lookDetail(){
      this.lookFlag = true;
      let params = {
        planId: this.currentStudent.planId,
        courseId: this.currentStudent.courseId,
        userId: this.currentStudent.userId,
      }
      const {code,data: activities} = await queryDetailListAPI(params)
      if (code == 1) {
        this.activities = activities;
      }
    },
    bigImg(item){
      window.open(item);
    },
    async lookDetailRight(){
      let params = {
        planId: this.currentStudent.planId,
        courseId: this.currentStudent.courseId,
        userId: this.currentStudent.userId,
      }
      const {code,data: activities} = await queryDetailListAPI(params)
      if (code == 1) {
        this.activities = activities;
      }
      this.showBubble = true;
    },
    closeBubble() {
      this.showBubble = false;
    },
    showBigImg(url) {
      window.open(url, "_blank");
    }
  },
};
</script>
<style lang="less" scoped>
/* *** 表单 label 样式, 防止表单 label 过长 *** */
.searchBox /deep/ .el-form-item__label {
  min-width: 120px;
  width: auto !important;
}

/* *** 表格左上方按钮样式 *** */
.batchOperation {
  margin-bottom: 16px;
  ul {
    display: flex;
    li {
      a {
        border-radius: 20px;
        border: 1px solid #e1e6ed;
        padding: 8px 20px;
        display: block;
        margin-right: 24px;
        font-size: 14px;
        color: #006aff;
        i {
          margin-right: 4px;
        }
      }
    }
  }
}

/* *** 表格左上方按钮禁用样式 *** */
.batchOperationDis {
  margin-bottom: 16px;
  ul {
    display: flex;
    // 图标颜色
    .iconfont {
      color: #606266 !important;
    }
    li {
      a {
        border-radius: 20px;
        border: 1px solid #e1e6ed;
        padding: 8px 20px;
        display: block;
        margin-right: 24px;
        font-size: 14px;
        color: #606266;
        cursor: not-allowed;
        i {
          margin-right: 4px;
        }
      }
    }
  }
}
.disciplineImg {
  padding: 20px;
  img {
    width: 115px;
    height: 162px;
  }
}
.dialogImg {
  display: flex;
  flex-flow: row wrap;
  margin-left:8% ;
}
.showImgClassInner {
  padding: 12px;
  img {
    width: 115px;
    height: 162px;
  }
}
.showImgClass {
  display: flex;
  flex-flow: row wrap;
  margin-left:20% ;
}
/* *** 弹窗 p 样式 *** */
.studentNumber {
  margin-bottom: 32px;
}

.topTip {
  height: 60px;
  display: flex;
  align-items: center;
  background-color: #ebf0fa;
  padding: 20px;
  border-radius: 8px 8px 0 0;
  box-sizing: border-box;
}

.tableBorder {
  background-color: #fff;
  padding-top: 20px;
  border-radius: 8px;
}

.searchBox {
  background-color: #fff;
  border-radius: 0 0 8px 8px;
}

.score_dialog {
  p {
    font-size: 16px;
    line-height: 36px;
  }

  .line {
    border-top: 1px dashed #ccc;
    margin: 16px 0;
  }
  .info {
    display: inline-block;
    margin-right: 16px;
    span {
      display: inline-block;
      text-align: right;
      font-weight: 700;
    }
  }
  .score {
    span:first-child {
      display: inline-block;
      width: 208px;
      text-align: right;
    }
  }
  .score.title {
    font-weight: 700;
  }
}
.BubbleTrigger {
  position: relative;
}

.bubbleSelf {
  position: absolute;
  top: -25px;
  left: 100%;
  margin-left: 15px;
  background: white;
  border-radius: 10px;
  padding: 12px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  width: 300px;
  border: 1px solid #ddd;
  z-index: 10;
}

.bubbleSelf::before {
  content: '';
  position: absolute;
  top: 32px;
  left: -10px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 10px solid white;
}

.bubbleSelf::after {
  content: '';
  position: absolute;
  top: 32px;
  left: -11px;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-top: 8px solid transparent;
  border-bottom: 8px solid transparent;
  border-right: 10px solid #ddd;
  z-index: -1;
}
.close-btn {
  position: absolute;
  top: 8px;
  right: 10px;
  background: none;
  border: none;
  font-size: 18px;
  color: #95a5a6;
  cursor: pointer;
  transition: color 0.2s;
}
.close-btn:hover {
  color: #e74c3c;
}
.imgCss{
  padding:3px;
  border:1px solid #ccc; 
  cursor: pointer;
  margin-top:8px;
}
</style>
